export const BLANK_PAGE_SKELETON = `
  <style>
    html {
      height: 100%;
      background: white;
    }
  </style>
  <div class="container" style="background-color: #ffffff; min-height: 100vh; padding: 20px;">
    <div class="row" style="color: #333;">
      <div class="col-sm-4"></div>
      <div class="col-sm-4"></div>
      <div class="col-sm-4"></div>
    </div>
  </div>`;
